import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { endpoints } from 'src/app/constants/endpoints';
import { IResponseBody } from 'src/app/interfaces/response-body';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { CommonFunctionService } from 'src/app/services/common-function.service';
import { environment } from 'src/environments/environment';
import { DateRange } from '../interfaces/date-range';
import { IEvent } from '../interfaces/event';

@Injectable()
export class EventApiService {
  constructor(
    protected Api: ApiService,
    private readonly auth: AuthService,
    protected commonFunctionService: CommonFunctionService,
    protected http: HttpClient,
  ) {}

  public listEvents(
    role: string,
    endpointUrl: string,
    filter?: {},
  ): Promise<IEvent[] | void> {
    const endpointConfig = endpoints.event[endpointUrl];
    let endpoint = `${environment.apiUrl}/${role}/${endpointConfig}`;
    const url = this.commonFunctionService.findApiUrl(role);

    endpoint = this.addFilterToEndpoint(endpoint, filter);
    return this.Api.get(endpoint, url)
      .then((Events: IEvent[]) => Events)
      .catch((error) => this.Api.handleError(error));
  }

  public listWithPageEvent(role: string, filter?: {}, PageEvent?: PageEvent) {
    let endpoint = `${role}/events`;
    const url = this.commonFunctionService.findApiUrl(role);
    return this.Api.getWithPageEventFilter(endpoint, PageEvent, filter, url)
      .then((ResponseBody: IResponseBody) => ResponseBody)
      .catch((error) => this.Api.handleError(error));
  }

  public listWithDateRange(
    role: string,
    endpointUrl: string,
    filter?: {},
    DateRange?: DateRange,
    PageEvent?: PageEvent,
  ) {
    const endpointConfig = endpoints.event[endpointUrl];
    let endpoint = `${role}/${endpointConfig}`;
    const url = this.commonFunctionService.findApiUrl(role);
    const startDate = moment(DateRange.startDate).format('YYYY-MM-DD');
    const endDate = DateRange.endDate
      ? moment(DateRange.endDate).format('YYYY-MM-DD')
      : startDate;

    return this.Api.getWithPageEventFilter(
      endpoint,
      PageEvent,
      {
        ...filter,
        startDate: startDate,
        endDate: endDate,
      },
      url,
    )
      .then((ResponseBody: IResponseBody) => ResponseBody)
      .catch((error) => this.Api.handleError(error));
  }

  protected addFilterToEndpoint(endpoint: string, filter?: {}) {
    if (!filter) {
      endpoint += `/type/null`;
    } else {
      Object.keys(filter).map((key) => {
        if (key === 'categoryId') {
          endpoint += `/category/${filter[key]}`;
        } else {
          const kebabKey = this.camelToDash(key);
          endpoint += `/${kebabKey}/${filter[key]}`;
        }
      });
    }

    return endpoint;
  }

  public camelToDash(str) {
    if (str != str.toLowerCase()) {
      str = str.replace(/[A-Z]/g, (m) => '-' + m.toLowerCase());
    }
    return str;
  }

  public async runManualBallot(id: Number) {
    try {
      const exchangeResponse = await this.auth.exchangePreviewTokens();
      const apiToken = exchangeResponse?.token;

      if (!apiToken) {
        throw new Error('Unauthorised');
      }

      await firstValueFrom(
        this.http.get(
          `${environment.leisureUrl}/json/admin/manualBallot/${id}`,
          {
            headers: {
              Authorization: apiToken,
            },
          },
        ),
      );
      await this.Api.handleSuccess('Manual ballot run.');
    } catch (e) {
      await this.Api.handleError(e);
    }
  }
}
